var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoUniCarePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2516_342)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.075 492.494C654.105 492.501 675.824 487.299 695.46 477.313C715.096 467.326 732.092 452.838 745.062 435.03C758.031 417.223 766.606 396.601 770.087 374.848C773.568 353.095 771.855 330.828 765.09 309.862C761.83 299.803 749.255 297.722 741.772 305.205L658.156 388.79C656.239 390.825 653.756 392.239 651.027 392.848C648.298 393.457 645.449 393.233 642.849 392.205C620.135 382.769 602.076 364.731 592.611 342.029C591.598 339.422 591.382 336.572 591.99 333.842C592.598 331.111 594.003 328.622 596.027 326.691L679.673 243.107C687.125 235.624 685.076 223.018 675.016 219.758C653.322 212.754 630.245 211.165 607.796 215.128C585.347 219.092 564.209 228.488 546.226 242.497C528.242 256.506 513.959 274.702 504.623 295.499C495.287 316.295 491.181 339.06 492.664 361.808C494.371 388.914 488.689 417.945 467.824 435.333L243.338 622.373C234.329 629.903 226.986 639.227 221.777 649.751C216.568 660.275 213.608 671.768 213.084 683.498C212.561 695.229 214.485 706.939 218.736 717.885C222.986 728.831 229.469 738.772 237.772 747.075C246.075 755.378 256.016 761.861 266.962 766.112C277.908 770.362 289.619 772.287 301.349 771.763C313.08 771.24 324.573 768.279 335.096 763.071C345.62 757.862 354.944 750.519 362.474 741.509L549.515 517.023C566.902 496.158 595.933 490.476 623.039 492.184C626.02 492.391 629.032 492.494 632.075 492.494ZM337.107 678.79C337.107 687.025 333.836 694.922 328.013 700.745C322.19 706.568 314.292 709.839 306.058 709.839C297.823 709.839 289.925 706.568 284.103 700.745C278.28 694.922 275.008 687.025 275.008 678.79C275.008 670.555 278.28 662.657 284.103 656.835C289.925 651.012 297.823 647.74 306.058 647.74C314.292 647.74 322.19 651.012 328.013 656.835C333.836 662.657 337.107 670.555 337.107 678.79Z",
    fill: "#1B635F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.17 539.049C637.552 539.049 642.871 538.821 648.129 538.366L764.688 654.924C779.247 669.484 787.426 689.23 787.426 709.82C787.426 730.409 779.247 750.156 764.688 764.715C750.129 779.274 730.383 787.453 709.793 787.453C689.203 787.453 669.457 779.274 654.898 764.715L517.971 627.787L585.41 546.842C587.024 544.917 589.974 542.557 596.029 540.756C603.893 538.695 612.052 537.991 620.154 538.676C624.128 538.924 628.133 539.049 632.17 539.049ZM368.251 324.374L440.596 396.719C439.884 397.747 439.049 398.685 438.112 399.513L393.091 437.021L324.347 368.278H284.698C281.817 368.278 278.993 367.476 276.542 365.963C274.091 364.449 272.109 362.284 270.819 359.708L218.035 254.078C216.576 251.167 216.07 247.87 216.588 244.655C217.107 241.44 218.623 238.469 220.922 236.163L236.137 220.949C238.439 218.644 241.408 217.122 244.623 216.599C247.839 216.075 251.137 216.576 254.052 218.03L359.682 270.814C362.266 272.109 364.438 274.101 365.952 276.564C367.466 279.027 368.263 281.864 368.251 284.755V324.374Z",
    fill: "#5A8381"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint0_linear_2516_342)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint1_linear_2516_342)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2516_342",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2516_342",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2516_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUniCarePlus);
export default __webpack_public_path__ + "static/media/Logo_UniCarePlus.9b8060ee5d99ad193234dd7f1f6f5860.svg";
export { ForwardRef as ReactComponent };